module.exports = __webpack_public_path__ + "img/14.96df1cef.jpg";